module.exports = __webpack_public_path__ + "img/6d0065d87b5256d62afacef9249d6fbc.8e560d3a.jpg";